import sanityClient from "./sanityClient";
import imageUrlBuilder from "@sanity/image-url";

// ── Image URL builder ──────────────────────────────────────────────────────
const builder = sanityClient ? imageUrlBuilder(sanityClient) : null;
export function urlFor(source) {
  return builder ? builder.image(source) : { url: () => "" };
}

// ── GROQ fragments ─────────────────────────────────────────────────────────
const ARTICLE_CARD_FIELDS = `
  _id,
  title,
  titleRu,
  "slug": slug.current,
  description,
  descriptionRu,
  author,
  publishedAt,
  category,
  tags,
  readingTime,
  featured,
  featuredImage { asset, alt, hotspot, crop }
`;

const ARTICLE_FULL_FIELDS = `
  ${ARTICLE_CARD_FIELDS},
  body[]{
    ...,
    _type == "image" => { ..., asset-> }
  },
  bodyRu[]{
    ...,
    _type == "image" => { ..., asset-> }
  },
  faq[] { question, answer, questionRu, answerRu },
  relatedArticles[]->{ ${ARTICLE_CARD_FIELDS} }
`;

// ── Queries ────────────────────────────────────────────────────────────────

/** Fetch all articles ordered by date desc */
export async function getAllArticles() {
  if (!sanityClient) return [];
  return sanityClient.fetch(
    `*[_type == "article"] | order(publishedAt desc) { ${ARTICLE_CARD_FIELDS} }`
  );
}

/** Fetch a single article by slug */
export async function getArticleBySlug(slug) {
  if (!sanityClient) return null;
  return sanityClient.fetch(
    `*[_type == "article" && slug.current == $slug][0] { ${ARTICLE_FULL_FIELDS} }`,
    { slug }
  );
}

/** Fetch featured article */
export async function getFeaturedArticle() {
  if (!sanityClient) return null;
  return sanityClient.fetch(
    `*[_type == "article" && featured == true] | order(publishedAt desc)[0] { ${ARTICLE_CARD_FIELDS} }`
  );
}

/** Fetch articles by category */
export async function getArticlesByCategory(category) {
  if (!sanityClient) return [];
  return sanityClient.fetch(
    `*[_type == "article" && category == $category] | order(publishedAt desc) { ${ARTICLE_CARD_FIELDS} }`,
    { category }
  );
}

// Categories are derived client-side from getAllArticles() — no separate endpoint needed
